import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

type AccordionLabelProps = {
  icon?: React.ReactNode
  className?: string
}

const AccordionLabel = ({ icon, children, className }: React.PropsWithChildren<AccordionLabelProps>) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.container, className)}>
      {icon} {children}
    </div>
  )
}

export default AccordionLabel

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})
